import Repository from 'Repository';

export class UsersRepository extends Repository {
    constructor() {
        super();

        this.resource = 'users';
    }
}

const Users = new UsersRepository;

export default Users;

/**
 * @typedef User
 * @type {object}
 * @property {number} user_id
 * @property {number} primary_user_id
 * @property {number} user_role_id
 * @property {string} display_name
 * @property {string} first_name
 * @property {string} last_name
 * @property {?string} email
 * @property {?string} pending_email
 * @property {?string} cell_phone
 * @property {?Certification[]} certifications
 * @property {?boolean} primary
 * @property {?boolean} sso_enabled
 * @property {boolean} mfa_enabled
 * @property {boolean} enforce_mfa
 * @property {?Entity} entity
 * @property {?Entity[]} entities
 * @property {?string} created_at
 * @property {?string} updated_at
 * @property {?User[]} all_users
 */
